import { FloorRequestStatus } from "../../../models/floor.model";

interface FloorRequestStatusBadgeProps {
  status: FloorRequestStatus;
  className?: string;
}

const statusStyles: Record<FloorRequestStatus, string> = {
  pending: "bg-yellow-100 text-yellow-800",
  approved: "bg-green-100 text-green-800",
  "partially fulfilled": "bg-orange-100 text-orange-800",
  fulfilled: "bg-blue-100 text-blue-800 ",
  rejected: "bg-red-100 text-red-800",
  cancelled: "bg-gray-100 text-gray-800",
  removed: "bg-red-100 text-red-800",
};

export default function FloorRequestStatusBadge({
  status,
  className = "",
}: FloorRequestStatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium capitalize ${statusStyles[status]} ${className}`}
    >
      {status}
    </span>
  );
}
